'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  'overlay': 'optix-inactivity-logout-ui__LoggedOutMessage__overlay___2UHz6',
  'dialog': 'optix-inactivity-logout-ui__LoggedOutMessage__dialog___2t65w',
  'content': 'optix-inactivity-logout-ui__LoggedOutMessage__content___31vPz',
  'buttonContainer': 'optix-inactivity-logout-ui__LoggedOutMessage__buttonContainer___2ExSB',
  'button': 'optix-inactivity-logout-ui__LoggedOutMessage__button___2D1mt'
};
var AUTH_LOGIN_BASE_URL = '/auth/login-page';
var LoggedOutMessage = function (_React$Component) {
  _inherits(LoggedOutMessage, _React$Component);
  function LoggedOutMessage(props) {
    _classCallCheck(this, LoggedOutMessage);
    var _this = _possibleConstructorReturn(this, (LoggedOutMessage.__proto__ || Object.getPrototypeOf(LoggedOutMessage)).call(this, props));
    _this.visibleElements = null;
    return _this;
  }
  _createClass(LoggedOutMessage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      /*
       * Ensure that assistive technology
       * announces the alert immediately
       */
      this.dialogButton.focus();

      /*
       * Hide content outside the dialog
       * in order to simplify focus management
       */
      var visibleElementsNodeList = document.querySelectorAll('body > :not([id=inactivity-logout]):not([hidden])');
      this.visibleElements = [].concat(_toConsumableArray(visibleElementsNodeList));
      this.visibleElements.forEach(function (element) {
        element.setAttribute('hidden', 'hidden');
      });

      /*
       * Refocus the dialog if user tries to leave it
       * (shift-TAB still escapes the dialog to the
       *  browser location bar, satisfying WCAG
       *  "no focus trap" guidelines)
       */
      this.dialogButton.addEventListener('keydown', function (event) {
        if ((event.keyCode || event.which) === 9) {
          _this2.dialogContent.focus();
          event.preventDefault();
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      /*
       * Restore visibility of page content
       * if the dialog is closed or destroyed
       */

      if (this.visibleElements) {
        this.visibleElements.forEach(function (element) {
          element.removeAttribute('hidden');
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;
      var forceNativeLoginPageParameter = this.props.useNativeLoginPage ? '&force_native_login_page=1' : '';
      var loginLinkWithNextUrl = AUTH_LOGIN_BASE_URL + '?next=' + encodeURIComponent(document.location) + forceNativeLoginPageParameter;
      return _react2.default.createElement('div', {
        className: styles.overlay
      }, _react2.default.createElement('section', {
        className: styles.dialog,
        role: 'dialog',
        'aria-labelledby': 'loggedOutLabel',
        'aria-describedby': 'loggedOutText'
      }, _react2.default.createElement('div', {
        className: styles.content,
        ref: function ref(node) {
          _this3.dialogContent = node;
        },
        role: 'document',
        tabIndex: '0'
      }, _react2.default.createElement('h1', {
        id: 'loggedOutLabel'
      }, 'Logged out'), _react2.default.createElement('p', {
        id: 'loggedOutText'
      }, 'For your safety, you\'ve been logged out after being idle for a while.')), _react2.default.createElement('div', {
        className: styles.buttonContainer
      }, _react2.default.createElement('a', {
        ref: function ref(node) {
          _this3.dialogButton = node;
        },
        className: styles.button,
        href: loginLinkWithNextUrl
      }, 'Log in'))));
    }
  }]);
  return LoggedOutMessage;
}(_react2.default.Component);
exports.default = LoggedOutMessage;
LoggedOutMessage.propTypes = {
  useNativeLoginPage: _propTypes2.default.bool.isRequired
};